export class XhrLoadingAnimation {
  constructor(attach_to_el, timeout_duration = 2000) {
    this.attach_to_el = attach_to_el
    this.timeout_duration = timeout_duration

  }

  start() {
    var image_el = document.createElement("img")
    image_el.src = "/images/xhr_loader1.svg"
    image_el.style.height = "40px"
    image_el.style.width = "40px"
    this.image_el = image_el

    var div_el = document.createElement("div")
    div_el.setAttribute("class", "xhr_loader_animation")
    div_el.style.display = "none"
    div_el.style.padding = "2rem"
    div_el.appendChild(image_el)
    this.loader_animation_el = div_el
    this.attach_to_el.appendChild(this.loader_animation_el)
    this.loader_timeout_id = setTimeout(() => {
      this.show()
    }, this.timeout_duration)
  }

  cancel() {
    this.loader_animation_el.style.display = "none"
    //this.attach_to_el.removeChild(this.loader_animation_el)
    clearTimeout(this.loader_timeout_id)
  }

  broken() {
    this.image_el.src = "/images/broken_mac.png"
  }

  show() {
    this.loader_animation_el.style.display = "block"
  }
}